import React from 'react';
import { CountdownScarcity } from './CountdownScarcity';
function TrainingBullets({
  className = ''
}: {
  className?: string;
}) {
  return <div className={className} data-id="element-78">
      <p className="text-base sm:text-xl text-gray-700 leading-relaxed mb-4 text-center lg:text-left" data-id="element-79">
        Meld je aan via het formulier op deze pagina en kies een datum om een
        van de gratis trainingen te volgen. In deze training leer je:
      </p>
      <ul className="text-left space-y-2 mb-6 sm:mb-8" data-id="element-80">
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-81">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-82">✓</span>
          <span data-id="element-83">
            Hoe je de "Verborgen Handleiding" van je hond vindt en zo beter
            samenwerkt dan ooit
          </span>
        </li>
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-84">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-85">✓</span>
          <span data-id="element-86">
            Wat dé sleutel is tot een harmonieus leven samen met je hond
          </span>
        </li>
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-87">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-88">✓</span>
          <span data-id="element-89">
            Welke mythes en miscommunicaties ongemerkt de vertrouwensband met je
            hond kunnen schaden (en hoe je ze voorkomt)
          </span>
        </li>
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-90">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-91">✓</span>
          <span data-id="element-92">
            Hoe honden echt in elkaar zitten en hoe jij ze voortaan beter
            begrijpt dan &gt;90% van de hondeneigenaren
          </span>
        </li>
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-93">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-94">✓</span>
          <span data-id="element-95">
            Hoe je probleemsituaties totaal anders kan laten verlopen en
            voortaan voorkomt zonder te corrigeren, straffen of commanderen
          </span>
        </li>
        <li className="flex items-start gap-2 text-sm sm:text-base text-gray-700" data-id="element-96">
          <span className="text-brand-mint mt-0.5 flex-shrink-0" data-id="element-97">✓</span>
          <span data-id="element-98">
            Hoe je de taal van je hond vloeiend leert spreken en je hond nóg
            gelukkiger maakt
          </span>
        </li>
      </ul>
    </div>;
}
export function Hero() {
  return <section className="bg-brand-lightMint pt-6 sm:pt-12 pb-10 sm:pb-20 px-4 sm:px-6 lg:px-8" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-8 items-start" data-id="element-101">
          {/* Left Column: Copy */}
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-102">
            <div className="inline-block bg-white border border-teal-100 text-brand-mint font-semibold px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm mb-3 sm:mb-6 shadow-sm" data-id="element-103">
              Gratis Online Webinar: Communiceren met je Hond
            </div>
            <h1 className="text-xl sm:text-3xl lg:text-4xl font-extrabold text-slate-800 leading-tight mb-3 sm:mb-6" data-id="element-104">
              Ontdek hoe je met liefdevolle communicatie de onderlinge{' '}
              <span className="text-brand-mint" data-id="element-105">
                band met je hond versterkt en problemen voorkomt
              </span>{' '}
              - zonder ooit nog te straffen of corrigeren
            </h1>

            {/* Bullets: only on desktop */}
            <TrainingBullets className="hidden lg:block" data-id="element-106" />

            {/* Trust indicators - hidden on mobile to save space */}
            <div className="hidden sm:flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm text-gray-600 font-medium" data-id="element-107">
              <div className="flex items-center gap-2" data-id="element-108">
                <div className="flex -space-x-2" data-id="element-109">
                  <img className="w-8 h-8 rounded-full border-2 border-white" src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=100&q=80" alt="User" data-id="element-110" />
                  <img className="w-8 h-8 rounded-full border-2 border-white" src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=100&q=80" alt="User" data-id="element-111" />
                  <img className="w-8 h-8 rounded-full border-2 border-white" src="https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=100&q=80" alt="User" data-id="element-112" />
                </div>
                <span data-id="element-113">Al 100.000+ baasjes gingen je voor</span>
              </div>
            </div>
          </div>

          {/* Right Column: Opt-in Form (Iframe) */}
          <div id="register-form" className="w-full flex flex-col items-center lg:items-end relative z-10" data-id="element-114">
            <div className="bg-white p-2 sm:p-4 rounded-[32px] shadow-xl w-full max-w-[440px] border border-teal-50" data-id="element-115">
              <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }} data-id="element-116">
                <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-gpmax_cmp-mcc_pt-advertorial-2" height="550" width="100%" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
                border: '1px solid #e2e8f0',
                borderRadius: '24px',
                maxWidth: '400px'
              }} data-teidentifier="3mhamcuxtgimg98yrud" data-id="element-117"></iframe>
              </div>
            </div>
            <CountdownScarcity data-id="element-118" />

            {/* Bullets: only on mobile, after timer/scarcity */}
            <TrainingBullets className="lg:hidden mt-6" data-id="element-119" />
          </div>
        </div>
      </div>
    </section>;
}